<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="dialog-header">
      <fa-icon [icon]="['fas', 'newspaper']"></fa-icon>
      <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
      @if (breadcrumbItems.length) {
        <nav class="preview-breadcrumb" aria-label="breadcrumb">
          <ol class="breadcrumb">
            @for (
              item of breadcrumbItems;
              track item.label;
              let first = $first
            ) {
              <li class="breadcrumb-item" [ngClass]="item.className">
                @if (!first) {
                  <span class="separator">
                    <fa-icon
                      [icon]="
                        item.className?.includes('dimension')
                          ? ['fas', 'link']
                          : ['fas', 'angle-right']
                      "
                      [transform]="
                        item.className?.includes('dimension')
                          ? { rotate: 25 }
                          : undefined
                      "
                    ></fa-icon>
                  </span>
                }
                <span class="breadcrumb-item-link">
                  @if (item.icon) {
                    <span class="icon">
                      <fa-icon [icon]="item.icon"></fa-icon>
                    </span>
                  }
                  <span class="label">{{ item.label }}</span>
                </span>
              </li>
            }
          </ol>
        </nav>
      }
    </div>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="closeDialog()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="card-tools">
      <sui-toolbar>
        <sui-button
          variant="ghost"
          [leadingIcon]="['fas', 'eye']"
          [trailingIcon]="['fas', 'caret-down']"
          [suiTooltip]="'feed-actions.button.view-tooltip' | translate"
          [suiPopoverTrigger]="viewPanel"
          suiPopoverPlacement="bottom-end"
          #viewTrigger="suiPopoverTrigger"
          [expanded]="viewTrigger.isOpen()"
        >
          {{ "feed-actions.button.view" | translate }}
        </sui-button>

        <ng-template #viewPanel>
          <div suiPopover class="dropdown-menu view-panel">
            @for (group of viewMenuGroups; track group) {
              @if (group.radioGroup) {
                <div
                  sui-radio-group
                  orientation="vertical"
                  [ngModel]="viewValues[group.radioGroup]"
                  [ngModelOptions]="{ standalone: true }"
                  (valueChange)="onViewRadioChange(group, $event)"
                >
                  @for (item of group.items; track item) {
                    <sui-radio
                      class="dropdown-item"
                      indicatorPosition="trailing"
                      [value]="$any(item.value)"
                    >
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item.text }}</span>
                    </sui-radio>
                  }
                </div>
              } @else {
                @for (item of group.items; track item) {
                  @if (item.isSeparator) {
                    <div class="dropdown-divider"></div>
                  } @else if (item.isTitle) {
                    <div class="dropdown-heading">
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item.text }}</span>
                    </div>
                  } @else {
                    <sui-checkbox
                      class="dropdown-item"
                      indicatorPosition="trailing"
                      [checked]="!!item.isSelected"
                      (checkedChange)="item.action?.()"
                    >
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item.text }}</span>
                    </sui-checkbox>
                  }
                }
              }
            }
          </div>
        </ng-template>
      </sui-toolbar>
    </div>
    <div class="tools">
      <div class="pagination-tools">
        <div class="items-per-page">
          <sui-select
            [ngModel]="itemsPerPage"
            (ngModelChange)="onItemsPerPageChange($event)"
          >
            @for (option of itemsPerPageOptions; track option) {
              <sui-select-option [value]="option">{{
                option
              }}</sui-select-option>
            }
          </sui-select>

          <div class="total-count">
            {{ "feed-results-preview.from" | translate }}
            <span class="bold">{{ totalItemsCount | number }}</span>
            {{ "feed-results-preview.total" | translate }}
          </div>
        </div>
        <div class="pagination-holder">
          <sui-pagination
            [pageSize]="itemsPerPage"
            [currentPage]="currentPage"
            [collectionSize]="totalItemsCount"
            (pageChanged)="onPageChanged($event)"
            (doPageChange)="onPageChanged(+$event)"
          ></sui-pagination>
        </div>
      </div>
    </div>
    @if (postsLoading) {
      <div class="fa-center">
        <fa-icon
          [icon]="['fas', 'spinner']"
          size="3x"
          animation="spin-pulse"
        ></fa-icon>
      </div>
    }

    @if (!postsLoading) {
      <div class="posts-preview-container">
        @if (posts.length === 0) {
          <div class="no-posts-message">
            {{ "feed-results-preview.no-posts" | translate }}
          </div>
        }

        @for (post of posts; track post.id) {
          <app-post-card
            [post]="post"
            [user]="user"
            [selectable]="false"
            [timeShown]="timeShown"
            [viewConfig]="viewConfig"
          ></app-post-card>
        }
      </div>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <div class="footer-wrapper">
      @for (button of buttons; track button.text) {
        <sui-button
          [variant]="button.variant || 'secondary'"
          [leadingIcon]="button.leadingIcon"
          [disabled]="button.disabled"
          [loading]="button.loading"
          (click)="button.action()"
        >
          {{ button.text }}
        </sui-button>
      }
    </div>
  </ng-template>
</sui-dialog-simple>
